import { FC } from 'react'
import { useSelector } from 'react-redux'
import cn from './index.module.css'
import { CheckCircleOutlined } from '@ant-design/icons'

interface ISuccessfullyEnrollmentStub {
  title: string
}

const SuccessfullyEnrollmentStub: FC<ISuccessfullyEnrollmentStub> = ({
  title,
}) => {
  const unpaidText = useSelector((store: any) => {
    return store.settings.isCustomPurchaseCardDescription === '1'
      ? store.settings.custom.customPurchaseCardDescription ?? null
      : null
  })

  return (
    <div className={cn.successStubWrapper}>
      <div className={cn.successStubWrapperIconWrapper}>
        <CheckCircleOutlined
          className={cn.successStubWrapperIcon}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </div>
      <div className={cn.successStubWrapperColumn}>
        <div className={cn.successStubTitle}>{title}</div>
        <div className={cn.successStubDescription}>
          {unpaidText ??
            'Ожидайте в течение дня с вами свяжется персональный менеджер для уточнения информации'}
        </div>
      </div>
    </div>
  )
}

export default SuccessfullyEnrollmentStub
